import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["category", "subCategory", "categories", "giftCardAccepted", "searchTerm"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { Stack } from '@hub/stack';
import { GridViewMediumIcon, ListViewMediumIcon } from '@hub/icon';
import { Box } from '@hub/box';
import { Button } from '@hub/button';
import { Text } from '@hub/text';
import { Checkbox } from '@hub/checkbox';
import { Grid, GridItem } from '@hub/grid';
import { find } from 'lodash';
import { useRouter } from 'next/router';
import { VisibleStores } from '../visible-stores';
import { SearchField } from '../search-field';
import { CategoryList } from './category-list';
import { categoryList, subCategoryList, filterStores } from './helper';
import { trackClickStoreDetailsLink } from './analytics';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function updateUrlSearchString(router, query) {
  var _query$subCategory;
  const _router$query = router.query,
    {
      category: _category,
      subCategory: _subcategory,
      categories: _categories,
      giftCardAccepted: _giftCardAccepted,
      searchTerm: _searchTerm
    } = _router$query,
    otherQueryParams = _objectWithoutProperties(_router$query, _excluded);
  router.push({
    pathname: router.pathname,
    query: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, otherQueryParams), query.giftCardAccepted ? {
      giftCardAccepted: query.giftCardAccepted
    } : {}), query.searchTerm ? {
      searchTerm: query.searchTerm
    } : {}), query.category ? {
      categories: [query.category.slug, (_query$subCategory = query.subCategory) === null || _query$subCategory === void 0 ? void 0 : _query$subCategory.slug].filter(el => Boolean(el))
    } : {})
  }, undefined, {
    shallow: true
  });
}
const updateStores = (router, setStoreList, stores, newQuery) => {
  updateUrlSearchString(router, newQuery);
  setStoreList(filterStores(stores, newQuery));
};
const handleOnChange = (router, setStoreList, retailCategories, stores, query, queryType, value) => {
  if (queryType === 'category') {
    updateUrlSearchString(router, _objectSpread(_objectSpread({}, query), {}, {
      category: find(retailCategories, {
        title: value
      }),
      subCategory: undefined
    }));
  } else if (queryType === 'subCategory') {
    updateUrlSearchString(router, _objectSpread(_objectSpread({}, query), {}, {
      subCategory: find(retailCategories, {
        title: value
      })
    }));
  } else {
    updateStores(router, setStoreList, stores, _objectSpread(_objectSpread({}, query), {}, {
      [queryType]: value
    }));
  }
};
export const StoreList = _ref => {
  var _category$title, _subCategory$title;
  let {
    stores,
    retailCategories,
    centre,
    query
  } = _ref;
  const router = useRouter();
  const categories = useMemo(() => categoryList(retailCategories), [retailCategories]);
  const {
    0: storesView,
    1: setStoresView
  } = useState('GRID');
  const {
    0: subcategories,
    1: setSubcategories
  } = useState([]);
  const {
    category,
    subCategory,
    giftCardAccepted,
    searchTerm
  } = query;
  const {
    0: searchTermValue,
    1: setSearchTermValue
  } = useState(searchTerm !== null && searchTerm !== void 0 ? searchTerm : '');
  const {
    0: giftCardAcceptedValue,
    1: setGiftCardAcceptedValue
  } = useState(giftCardAccepted !== null && giftCardAccepted !== void 0 ? giftCardAccepted : false);
  const {
    0: storeList,
    1: setStoreList
  } = useState(stores);
  useEffect(() => {
    setStoreList(filterStores(stores, {
      giftCardAccepted,
      searchTerm
    }));
  }, [stores, giftCardAccepted, searchTerm]);
  const handleClearAll = useCallback(() => {
    updateStores(router, setStoreList, stores, {});
    setGiftCardAcceptedValue(false);
    setSearchTermValue('');
  }, [router, stores]);
  useEffect(() => {
    if (category) {
      setSubcategories(subCategoryList(retailCategories, category.title));
    } else {
      setSubcategories([]);
    }
  }, [category, retailCategories]);
  return /*#__PURE__*/_jsxs(Stack, {
    "data-id": "store-list_index_StoreList_Stack",
    children: [/*#__PURE__*/_jsx(Text, {
      sx: {
        fontSize: 'font-2xl',
        fontWeight: 'bold',
        marginBottom: 'spacing-lg'
      },
      "data-id": "store-list_index_StoreList_Stack_Text",
      children: "Browse stores"
    }), /*#__PURE__*/_jsx(Stack, {
      sx: {
        marginBottom: 'spacing-lg'
      },
      "data-id": "store-list_index_StoreList_Stack_Stack",
      children: /*#__PURE__*/_jsxs(Grid, {
        sx: {
          gridGap: ['spacing-md']
        },
        templateColumns: ['repeat(1, 1fr)', 'repeat(1, 1fr)', 'repeat(3, 1fr)'],
        "data-id": "store-list_index_StoreList_Stack_Grid",
        children: [/*#__PURE__*/_jsx(GridItem, {
          "data-id": "store-list_index_StoreList_Grid_GridItem",
          children: /*#__PURE__*/_jsx(SearchField, {
            id: "searchInp",
            placeholder: "Find stores in ".concat(centre.title),
            value: searchTermValue,
            autoCorrect: "off",
            autoComplete: "off",
            onChange: e => {
              setSearchTermValue(e.target.value);
              handleOnChange(router, setStoreList, retailCategories, stores, query, 'searchTerm', e.target.value);
            },
            "data-id": "store-list_index_StoreList_GridItem_SearchField"
          })
        }), /*#__PURE__*/_jsx(GridItem, {
          "data-id": "store-list_index_StoreList_Grid_GridItem",
          children: categories.length > 0 && /*#__PURE__*/_jsx(CategoryList, {
            categories: categories,
            value: (_category$title = category === null || category === void 0 ? void 0 : category.title) !== null && _category$title !== void 0 ? _category$title : '',
            placeholder: "Choose category",
            onChange: value => handleOnChange(router, setStoreList, retailCategories, stores, query, 'category', value),
            "data-id": "store-list_index_StoreList_CategoryList"
          })
        }), /*#__PURE__*/_jsx(GridItem, {
          "data-id": "store-list_index_StoreList_Grid_GridItem",
          children: category && subcategories.length > 0 && /*#__PURE__*/_jsx(CategoryList, {
            categories: subcategories,
            value: (_subCategory$title = subCategory === null || subCategory === void 0 ? void 0 : subCategory.title) !== null && _subCategory$title !== void 0 ? _subCategory$title : '',
            placeholder: "Choose subcategory",
            onChange: value => handleOnChange(router, setStoreList, retailCategories, stores, query, 'subCategory', value),
            "data-id": "store-list_index_StoreList_CategoryList"
          })
        })]
      })
    }), /*#__PURE__*/_jsxs(Stack, {
      direction: "row",
      shouldWrapChildren: false,
      sx: {
        alignItems: 'baseline',
        marginBottom: 'spacing-lg'
      },
      "data-id": "store-list_index_StoreList_Stack_Stack",
      children: [/*#__PURE__*/_jsxs(Box, {
        sx: {
          flexGrow: 1
        },
        "data-id": "store-list_index_StoreList_Stack_Box",
        children: [/*#__PURE__*/_jsx(Checkbox, {
          isChecked: giftCardAcceptedValue,
          sx: {
            marginRight: 'spacing-md'
          },
          onChange: () => {
            setGiftCardAcceptedValue(!giftCardAcceptedValue);
            handleOnChange(router, setStoreList, retailCategories, stores, query, 'giftCardAccepted', !giftCardAcceptedValue);
          },
          "data-id": "store-list_index_StoreList_Box_Checkbox",
          children: "Gift cards"
        }, "GiftCards"), /*#__PURE__*/_jsx(Button, {
          sx: {
            textDecoration: 'underline',
            fontWeight: 'normal',
            padding: 'spacing-none',
            height: 'spacing-md',
            textTransform: 'none',
            color: 'licorice'
          },
          variant: "link",
          onClick: handleClearAll,
          "data-id": "store-list_index_StoreList_Box_Button",
          children: "Clear all"
        })]
      }), /*#__PURE__*/_jsxs(Box, {
        sx: {
          flexGrow: 0
        },
        "data-id": "store-list_index_StoreList_Stack_Box",
        children: [/*#__PURE__*/_jsx("button", {
          onClick: () => setStoresView('GRID'),
          "data-id": "store-list_index_StoreList_Box_button",
          children: /*#__PURE__*/_jsx(GridViewMediumIcon, {
            sx: {
              boxSize: 'size-icon-md',
              color: storesView !== 'GRID' && 'manatee',
              marginRight: 'spacing-md',
              marginLeft: 'spacing-md'
            },
            "data-id": "store-list_index_StoreList_button_GridViewMediumIcon"
          })
        }), /*#__PURE__*/_jsx("button", {
          onClick: () => setStoresView('LIST'),
          "data-id": "store-list_index_StoreList_Box_button",
          children: /*#__PURE__*/_jsx(ListViewMediumIcon, {
            sx: {
              boxSize: 'size-icon-md',
              color: storesView !== 'LIST' && 'manatee'
            },
            "data-id": "store-list_index_StoreList_button_ListViewMediumIcon"
          })
        })]
      })]
    }), storeList.length > 0 ? /*#__PURE__*/_jsx(VisibleStores, {
      centre: centre.slug,
      stores: storeList,
      storesView: storesView,
      onClick: trackClickStoreDetailsLink,
      "data-id": "store-list_index_StoreList_VisibleStores"
    }) : /*#__PURE__*/_jsxs(Box, {
      sx: {
        marginTop: 'spacing-md',
        textAlign: 'center'
      },
      "data-id": "store-list_index_StoreList_Box",
      children: [/*#__PURE__*/_jsx(Text, {
        sx: {
          fontSize: 'font-2xl',
          fontWeight: 'bold',
          marginBottom: 'spacing-sm'
        },
        "data-id": "store-list_index_StoreList_Box_Text",
        children: "No matching stores"
      }), /*#__PURE__*/_jsx(Text, {
        "data-id": "store-list_index_StoreList_Box_Text_22",
        children: "Try changing categories or removing filters"
      })]
    })]
  });
};